import PerfilDaLoja from './store'

export default {
    PerfilDaLoja
}